import React from "react";
import setFallbackAvatar from "../../utils/setFallbackAvatar";
import { Link } from "react-router-dom";
import css from './TableBuilder.module.scss';

/**
 * @class
 *
 * The footer found throughout the app.
 *
 * This component is automatically included in views/pages once the user successfully logs in.
 * All links, text, etc. are hard-coded; updating them requires manually changing them here.
 */

const TableBuilder = (props) => {
  return (
    <div className={css.TableBuilder}>
      <table>
        <thead>
        <tr>
            <th>Rank</th>
            <th colSpan="2">Sales Rep</th>
            <th className="d-md-block d-none">Office</th>
            <th>Sales</th>
        </tr>
        </thead>
        <tbody>
          {props.reps.map((rep, index) =>
            <tr key={rep.id}>
                <td>{index+1}</td>
                { /* N.b. because the sales rep images are in the `/public` folder, we can access them through root and we don't need `require()`: */ }
                { /* If Sales Rep image doesn't exist, show default avatar: */}
                <td><img src={`https://v3-portal-file-storage.s3.us-west-2.amazonaws.com/repPhotos/${rep.name}.jpg`} alt='Sales Rep Portrait' onError={(event) => setFallbackAvatar(event)} /></td>
                {/* <td><img src={`/images/${rep.name}.jpg`} alt='Sales Rep Portrait' onError={(event) => setFallbackAvatar(event)} /></td> */}
                <td>
                    <Link to={`/repStats/${rep.id}`}>{rep.name}</Link>
                    {/* office text in mobile: */}
                    <div className="d-md-none">{rep.office}</div>
                </td>
                <td className="d-none d-md-table-cell">
                  {rep.office}
                </td>
                <td>
                    <h3>{rep.csd}</h3>
                </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableBuilder;